import type { DefinitionBlockComponent, Reference, BlockComponent, CommonProperties } from "../survey";

export const ReferenceableBlocks = ['Attachment','Explanation','Select','Validated'] as const;
export type ReferenceableBlock = typeof ReferenceableBlocks[number];
export type ReferenceBlocks = `${typeof ReferenceableBlocks[number]} Reference`;
export const referenceBlocksArray: ReferenceBlocks[] = ReferenceableBlocks.map(b => `${b} Reference` as const);

export function replaceReferenceWithDefinition(reference: Reference & CommonProperties, definition: DefinitionBlockComponent): BlockComponent & { id: string } | null {
  // First check that the definition is the same kind as the reference and that the ids match
  if (reference.kind !== (definition.kind + ' Reference') || reference.definitionId !== definition.definitionProps.id) {
    console.error("Reference", reference, "is not the same kind as the definition", definition);
    return null;
  }

  // Overwrite the Reference kind with the Definition kind
  //   e.g. Validated Reference -> Validated
  // Remove the definitionId from the new object. We don't need it anymore.
  // We will then overwrite any other definition props with any relevant reference props
  //   e.g. hidden, optional, content, etc.
  const omitReferenceProps = ['kind', 'definitionId'] as const;
  type ReferencePropsToKeep = Partial<Omit<Reference & CommonProperties, typeof omitReferenceProps[number]>>;

  const referenceProps = Object.entries(reference).filter(([key, _]) => !omitReferenceProps.includes(key as typeof omitReferenceProps[number])).reduce((acc, [key, value]) => {
    (acc as Record<string, any>)[key] = value;
    return acc;
  }, {} as ReferencePropsToKeep);

  return {
    ...definition,
    id: reference.id,
    ...referenceProps
  } satisfies BlockComponent & { id: string };
}